import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
class MouseMoveBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.mouseout;
        this.handler = (event) => this.onMouseOut(event);
    }
    onMouseOut(event) {
        const { clientX, clientY, relatedTarget } = event;
        if (relatedTarget == null) {
            const { innerWidth, innerHeight } = window;
            let direction = "";
            if (clientX < 0) {
                direction = "left";
            }
            else if (clientY < 0) {
                direction = "top";
            }
            else if (innerWidth < clientX) {
                direction = "right";
            }
            else if (innerHeight < clientY) {
                direction = "bottom";
            }
            if (direction.length > 0) {
                this.addLog(event, this.id, { direction });
            }
        }
    }
}
export default MouseMoveBehavior;
